import React from 'react';
import { useFetchClientOffer } from './fetchClientOffers';
import { Tables } from '../../../../../../Components';
import { offerTrackingHeaderData } from './headerData';
import { useTranslation } from 'react-i18next';
import { isEqual } from 'lodash';

const OfferTracking = () => {
  const { result, totalCount, filter, setFilter, isLoading, firstFetchEmpty } =
    useFetchClientOffer();
  const { t } = useTranslation('ClientsTracking');
  const onFilterValuesChanged = (filterValue) => {
    if (filterValue && !!Object.values(filterValue).length) {
      const { value, searchableKey } = Object.values(filterValue)[0];
      setFilter((filter) => ({
        ...filter,
        [searchableKey]: value,
      }));
    } else {
      const updatedFilter = Object.fromEntries(
        Object.entries(filter).filter(([_key, value]) => !!value || value === 0)
      );
      if (!isEqual(updatedFilter, filter)) {
        setFilter(updatedFilter);
      }
    }
  };

  if (firstFetchEmpty && !isLoading) {
    return <h2 className='text-center py-5'>{t('no_offers_found')}</h2>;
  }
  return (
    <div className='py-5 px-1'>
      <Tables
        headerData={offerTrackingHeaderData(t)}
        isLoading={isLoading}
        data={result}
        totalItems={totalCount}
        activePage={filter.pageIndex - 1}
        itemsPerPage={filter.pageSize}
        parentTranslationPath={'ClientsTracking'}
        filterData={offerTrackingHeaderData((data) =>
          setFilter((prevFilter) => ({ ...prevFilter, ...data }))
        ).map((item) => ({ ...item, component: item.filterComponent }))}
        FilterDisabledButton
        isWithFilter
        onPageIndexChanged={(pageIndex) =>
          setFilter({ ...filter, pageIndex: pageIndex + 1 })
        }
        onPageSizeChanged={(pageSize) => setFilter({ ...filter, pageSize })}
        onFilterValuesChanged={onFilterValuesChanged}
        setSortBy={(e) =>
          setFilter((prevFilter) => ({
            ...prevFilter,
            sortBy: e.filterBy,
            orderBy: e.orderBy,
          }))
        }
      />
    </div>
  );
};

export default OfferTracking;
